import RatingBar from '../RatingBar/RatingBar';
import { IReview } from '../../../model/reviews';
import defaultUserImg from '../../../assets/images/icons/default-user.jpg';

import styles from './styles.module.scss';
import { formatDate, upperWord } from '../../../helpers/functions';

const ReviewItem = ({ id, date, name, rating, review, patchData }: IReview) => {
  return (
    <div className={styles.reviewItem}>
      <div className={styles.userInfo}>
        <img src={defaultUserImg} alt="" />
        <span>{name}</span>
      </div>
      <div className={styles.date}>{formatDate(date)}</div>
      <div className={styles.ratingWrapper}>
        <RatingBar rating={rating} />
      </div>
      <div className={styles.description}><span className={styles.patchdata}>({upperWord(patchData?.size)}):</span> {review}</div>
    </div>
  );
};

export default ReviewItem;
